import Table from "@/app/charts/Table";

export default function ChartSection({ title, Chart, table }) {
  return (
    <div className="mt-5 shadow-lg p-5">
      <h2 className="text-2xl font-bold text-blue-700">{title}</h2>
      <hr className="border-b border-gray-300 my-4 w-1/6" />
      <div className="flex flex-col md:flex-row gap-5 justify-center items-center">
        <div className="w-full md:w-1/3 h-80 overflow-auto">
          <Table columnNames={Object.values(table[0])} rowValues={table[1]} />
        </div>
        <div className="w-full md:w-2/3">{Chart}</div>
      </div>
    </div>
  );
}
